<template>
  <router-view />
</template>


<script>
export default {
  metaInfo() {
    return {
      titleTemplate: `%s | ${this.$t("projectName")}`,
      htmlAttrs: { lang: "ar" },
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
      ],
    };
  },
};
</script>